import { AppLookupResponse } from './app-lookup-response';
import { FormGroup } from '@angular/forms';

export class Profile {
    public id: string;
    public accountId: string;
    public firstName: string;
    public lastName: string;
    public email: string;
    public phone: string;
    public sector: string;
    public dob: Date | null;
    public gender: string;
    public title: string;
    public salary: number;
    public salaryType: string;
    public description: string;
    public facebookLink: string;
    public twitterLink: string;
    public linkedinLink: string;
    public address: string;
    public city: string;
    public country: string;
    public photoPath: string;
    public languages: AppLookupResponse[];
    public educationLevel: string;
    public experience: number;

    public static parse(jsonData: any): Profile {
        let profile = new Profile();
        profile = Object.assign(profile, jsonData);
        if(profile.dob) {
            profile.dob = new Date(profile.dob);
        }
        
        return profile;
    }

    public static parseForm(form: FormGroup): Profile {
        let profile = new Profile();
        profile = Object.assign(profile, form.value);
        if(form.value.dob) {
            profile.dob = new Date(form.value.dob["year"], form.value.dob["month"], form.value.dob["day"]);
        }
        
        profile.salary = Number.parseInt(profile.salary.toString());
        return profile;
    }
}
